interface GlowProps {
  className?: string;
  /** Add a soft breathing pulse (disabled under reduced-motion). */
  pulse?: boolean;
}

/**
 * Decorative ambient brand glow. Purely visual — always aria-hidden. Colour
 * follows the themeable accent (orange / neon green).
 */
export function Glow({ className = '', pulse = false }: GlowProps) {
  return (
    <div
      aria-hidden="true"
      className={[
        'pointer-events-none absolute -z-10 glow-radial-orange',
        pulse ? 'motion-safe:animate-glow-pulse' : '',
        className,
      ].join(' ')}
    />
  );
}
